module.exports = __webpack_public_path__ + "static/img/login_ad.dc3028a1.png";